// extracted by mini-css-extract-plugin
export default {"schedule":"schedule_schedule__zPes2","box40":"schedule_box40__iACGF","banners__loading":"schedule_banners__loading__YIuVy"};